// extracted by mini-css-extract-plugin
module.exports = {"header":"Quiz_header__1VBXT","linkGroup":"Quiz_linkGroup__nBnNO","buttonGroup":"Quiz_buttonGroup__3aoOf","info":"Quiz_info__2mTJY"};